import { STATUS } from "@/lib/tp";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";
import { Check } from "lucide-react";

export default function StatusPill({ status, onChange, testId }) {
  const s = STATUS[status] || STATUS.da_fare;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          data-testid={testId}
          className="inline-flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-xs font-semibold uppercase tracking-wider transition-transform hover:scale-105 active:scale-95"
          style={{
            background: s.bg,
            border: `1px solid ${s.border}`,
            color: s.text,
          }}
        >
          <span
            className="inline-block h-1.5 w-1.5 rounded-full"
            style={{ background: s.text }}
          />
          {s.label}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="tp-glass-strong border-white/10 text-white">
        {Object.values(STATUS).map((opt) => (
          <DropdownMenuItem
            key={opt.key}
            onClick={() => onChange && onChange(opt.key)}
            className="flex items-center justify-between gap-4 focus:bg-white/10"
          >
            <span className="flex items-center gap-2">
              <span
                className="inline-block h-2 w-2 rounded-full"
                style={{ background: opt.text }}
              />
              {opt.label}
            </span>
            {opt.key === status && <Check size={14} />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
